import React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import eeLogo from './images/ee-logo.png';

/*
  Global Header
  - White background
  - Left: site logo (ee-logo.png)
  - Right: "Back to Main Site" button linking to main domain (opens same tab)
  - Sticky at top for profile pages, optional for card mode
*/

const Header = ({ mainSiteUrl = 'https://energyefficiency.ie', dense = false, logoHeight }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // Allow override via prop; otherwise pick larger baseline heights
  const computedLogoHeight = logoHeight || (dense ? 48 : 64); // increased from 38/46 -> 48/64
  const height = Math.max(dense ? 62 : 86, computedLogoHeight + 18); // ensure header comfortably wraps logo
  const horizontalPadding = isMobile ? 16 : 40;

  return (
    <Box
      component="header"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1200,
        backgroundColor: '#fff',
        borderBottom: '1px solid #e2e8f0',
        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        wrap="nowrap"
        sx={{
            maxWidth: 1400,
            margin: '0 auto',
            minHeight: height,
            px: `${horizontalPadding}px`,
        }}
      >
        {/* Logo */}
        <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
          <a href={mainSiteUrl} style={{ display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }}>
            <img
              src={eeLogo}
              alt="Energy Efficiency"
              style={{
                height: isMobile ? Math.min(computedLogoHeight, 54) : computedLogoHeight,
                width: 'auto',
                display: 'block',
                objectFit: 'contain'
              }}
            />
          </a>
        </Grid>

        <Grid item xs />

        {/* Back Button */}
        <Grid item>
          <Button
            variant="outlined"
            color="primary"
            size={isMobile ? 'small' : 'medium'}
            onClick={() => { window.location.href = mainSiteUrl; }}
            sx={{
              fontWeight: 600,
              textTransform: 'none',
              borderRadius: '30px',
            }}
          >
            {isMobile ? 'Back' : 'Back to Main Site'}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Header;
